import {
  isDate,
  isEmpty,
} from 'lodash';
import { stripNilProps } from './common.utilities';
import {
  RecordObject
} from '../models/common.models';

export const scrubProps = (obj: Record<string, string | number | Date | boolean | string[]>): RecordObject => {
  if (!obj || isEmpty(obj)) {
    return {};
  }
  const copy = stripNilProps(obj);
  Object.keys(copy).forEach((key) => {
    if (copy[key] === '') {
      delete copy[key];
    } else if (copy[key] === true || copy[key] === false) {
      copy[key] = copy[key].toString();
    } else if (isDate(copy[key])) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      copy[key] = copy[key].getTime();
    } else if (!isNaN(<number>copy[key])) {
      copy[key] = parseFloat(<string>copy[key]);
    }
  });
  return copy;
};
